/* eslint-disable no-undef */
import React, { use, useEffect, useRef, useState } from 'react';
import {
  Engine,
  Scene,
  FreeCamera,
  Vector3,
  HemisphericLight,
  SceneLoader,
  Color4,
  MeshBuilder,
  StandardMaterial,
  DirectionalLight,
  Color3,
  VideoTexture,
  Texture,
  DynamicTexture,
  Tools
} from '@babylonjs/core';
import { AdvancedDynamicTexture, TextBlock } from '@babylonjs/gui';
import '@babylonjs/loaders';
import './App.css';
import { RiResetLeftLine } from 'react-icons/ri';
import { IoHome } from 'react-icons/io5';
import { FaHeadSideVirus } from 'react-icons/fa6';

import slide1ENG from './media/images/Slide_1_nuova immagine_ENG.png';
import slide1ITA from './media/images/Slide_1_nuova immagine_ITA.png';
import slide2ENG from './media/images/Slide_2_nuova immagine_ENG.png';
import slide2ITA from './media/images/Slide_2_nuova immagine_ITA.png';
import slide3ENG from './media/images/Slide_3_nuova immagine_ENG.png';
import slide3ITA from './media/images/Slide_3_nuova immagine_ITA.png';
import slide4ENG1 from './media/images/Slide_4_nuova immagine1_ENG.png';
import slide4ITA1 from './media/images/Slide_4_nuova immagine1_ITA.png';
import slide4ENG2 from './media/images/Slide_4_nuova immagine2_ENG.png';
import slide4ITA2 from './media/images/Slide_4_nuova immagine2_ITA.png';
import slide5ENG from './media/images/Slide_5_nuova immagine_ENG.png';
import slide5ITA from './media/images/Slide_5_nuova immagine_ITA.png';
import slide6ENG from './media/images/Slide_6_nuova immagine_ENG.png';
import slide6ITA from './media/images/Slide_6_nuova immagine_ITA.png';
import video6ENG from './media/images/Slide_6_Video dentro Screen_ENG.mov';
import video6ITA from './media/images/Slide_6_Video dentro Screen_ITA.mov';
import slide7ENG from './media/images/Slide_7_nuova immagine_ENG.png';
import slide7ITA from './media/images/Slide_7_nuova immagine_ITA.png';
import video8ENG from './media/images/Slide_8_Video dentro Screen_ENG.mov';
import video8ITA from './media/images/Slide_8_Video dentro Screen_ITA.mov';
import video9ENG from './media/images/Slide_9_Video dentro Screen_ENG.mov';
import video9ITA from './media/images/Slide_9_Video dentro Screen_ITA.mov';
import slide10ENG from './media/images/Slide_10_nuova immagine_ENG.png';
import slide10ITA from './media/images/Slide_10_nuova immagine_ITA.png';
import AvatarENG from './media/videos/VIDEO MAJOR TUNNEL.mp4';

import italyFlag from './media/images/Flag_of_Italy.png'; // Add Italian flag image
import ukFlag from './media/images/UK_flag.png'; // Add UK flag image

// import metroMilano2 from './media/images/Metro milano 2.jpg';

import MajorVirtualTunnelLogo from './media/images/Major Tunnel logo.jpg';

import video1Avatar from './media/videos/AVATAR 2.mp4';

import Loader from './loader';
import Intro from './Intro';
import Outtro from './Outtro';

const App = () => {
  const canvasRef = useRef(null);
  const cameraRef = useRef(null);
  const trajectoryRef = useRef([]);
  const currentIndexRef = useRef(0); // Track current index using a ref
  const videoTexturesRef = useRef([]); // Store references to all video textures

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  const [showPortal, setShowPortal] = useState(false);
  const [showPortalView, setShowPortalView] = useState(true);

  const [showOuttro, setShowOuttro] = useState(false);
  const [language, setLanguage] = useState(window.location.pathname.replace('/', '')); // Default language is English
  const [dropdownVisible, setDropdownVisible] = useState(false); // Toggle dropdown visibility

  const touchStartYRef = useRef(null);
  const lastTouchYRef = useRef(null);
  const velocityRef = useRef(0);
  const lastTouchTimeRef = useRef(null);
  const momentumIntervalRef = useRef(null);

  const changeLanguage = (lang) => {
    // Update the URL path and reload the page
    window.history.pushState(null, '', `/${lang}`);
    setDropdownVisible(false); // Close the dropdown after selection
    window.location.reload(); // Reload the page to apply the new language
  };

  const handleEnterClick = () => {
    // Interact with Babylon.js video textures
    videoTexturesRef.current.forEach((videoTexture) => {
      if (videoTexture && videoTexture.video) {
        videoTexture.video.muted = false; // Unmute the video
        videoTexture.video.currentTime = 0; // Restart the video
        videoTexture.video.play().catch((e) => {
          console.warn('Video play blocked:', e);
        });
      }
    });
    console.log('here');
    // resetCameraPosition();
    setShowPortal(false); // Hide portal
    setShowPortalView(false);
    setShowOuttro(false);
  };

  const handleOuttroClick = () => {
    window.location.assign(
      window.location.pathname.replace('/', '') === 'eng' ? 'https://www.majorvirtual.it/en' : 'https://majorvirtual.it'
    );
  };

  const handleAVATRClick = () => {
    window.location.assign(
      'https://majorvisual.net/green/main/exe/?token=25&sensor=yes&type=1V&model=119&VD=40&VT=0&VRS=1&VRM=0.7&LO=1&G=F&open=CT&words=50&CO=ai2&user=161'
    ); // Redirect to the website
  };

  const [loading, setLoading] = useState(true);
  // const [showPortal, setShowPortal] = useState(false);

  // const moveToPosition = (point) => {
  //   const camera = cameraRef.current;
  //   if (camera && point) {
  //     camera.position = new Vector3(point.position.x, point.position.y, point.position.z);
  //     camera.rotation = new Vector3(point.rotation.x, point.rotation.y, point.rotation.z);
  //   }
  // };

  // const handleScroll = (event) => {
  //   const trajectory = trajectoryRef.current;
  //   if (trajectory.length === 0) return;

  //   const scrollThreshold = 5;

  //   let accumulatedScroll = (currentIndexRef.scrollAccumulated || 0) + event.deltaY;
  //   currentIndexRef.scrollAccumulated = accumulatedScroll;

  //   if (Math.abs(accumulatedScroll) >= scrollThreshold) {
  //     const direction = accumulatedScroll > 0 ? 1 : -1;
  //     currentIndexRef.scrollAccumulated = 0;

  //     let newIndex = currentIndexRef.current + direction;
  //     newIndex = Math.max(0, Math.min(newIndex, trajectory.length - 1));

  //     if (newIndex !== currentIndexRef.current) {
  //       currentIndexRef.current = newIndex;
  //       moveToPosition(trajectory[newIndex]);

  //       // Check if we are at the very end of the trajectory
  //       if (newIndex === trajectory.length - 1) {
  //         setShowPortal(false); // Show the intro page
  //         setShowOuttro(true);
  //       }
  //     }
  //   }
  // };

  // const handleTouchStart = (e) => {
  //   if (momentumIntervalRef.current) {
  //     clearInterval(momentumIntervalRef.current); // stop momentum if active
  //   }

  //   touchStartYRef.current = e.touches[0].clientY;
  //   lastTouchYRef.current = e.touches[0].clientY;
  //   lastTouchTimeRef.current = Date.now();
  //   velocityRef.current = 0;
  // };

  // const handleTouchMove = (e) => {
  //   const currentY = e.touches[0].clientY;
  //   const currentTime = Date.now();
  //   const deltaY = lastTouchYRef.current - currentY;
  //   const deltaTime = currentTime - lastTouchTimeRef.current;

  //   // Calculate velocity
  //   velocityRef.current = deltaY / deltaTime;

  //   // Scroll as the user moves the finger
  //   handleScroll({ deltaY });

  //   lastTouchYRef.current = currentY;
  //   lastTouchTimeRef.current = currentTime;
  // };

  // const handleTouchEnd = () => {
  //   const friction = 0.95; // Decay factor for momentum
  //   const minVelocity = 0.01;

  //   let velocity = velocityRef.current * 20; // Scale for scroll sensitivity

  //   momentumIntervalRef.current = setInterval(() => {
  //     if (Math.abs(velocity) < minVelocity) {
  //       clearInterval(momentumIntervalRef.current);
  //       return;
  //     }

  //     handleScroll({ deltaY: velocity }); // simulate scroll step
  //     velocity *= friction;
  //   }, 16); // roughly 60fps
  // };

  // useEffect(() => {
  //   if (!canvasRef.current) return;

  //   const engine = new Engine(canvasRef.current, true);
  //   const scene = new Scene(engine);
  //   scene.clearColor = new Color4(0, 0, 0, 1); // Black background

  //   const camera = new FreeCamera('camera', new Vector3(-124.84082921744432, 1.6948401426078026, 2.9335290880078633), scene);
  //   camera.rotation = new Vector3(0.29788111115053206, 2.2543863203579146, 0);
  //   cameraRef.current = camera;

  //   if (isMobileDevice()) {
  //     camera.fov = Tools.ToRadians(80); // wider FoV for mobile
  //   }

  //   new HemisphericLight('light', new Vector3(0, 1, 0), scene);

  //   const light = new DirectionalLight('directionalLight', new Vector3(0, -1, 0), scene);
  //   light.intensity = 1; // Bright light

  //   new Promise((resolve, reject) => {
  //     SceneLoader.ImportMesh(
  //       '',
  //       '/major-tunnel-model.glb',
  //       '',
  //       scene,
  //       (meshes) => {
  //         console.log('Model loaded successfully:', meshes);
  //         resolve();
  //       },
  //       undefined,
  //       (error) => {
  //         console.error('Error loading model:', error);
  //         reject(error);
  //       }
  //     );
  //   }).then(() => {
  //     setTimeout(() => {
  //       setShowPortal(true); // Show portal
  //     }, 1000);
  //   });

  //   const loadTrajectory = async () => {
  //     try {
  //       const response = await fetch('/trajectory.json');
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       const json = await response.json();
  //       trajectoryRef.current = json;

  //       if (json.length > 0) {
  //         moveToPosition(json[0]);
  //       }
  //     } catch (err) {
  //       console.error('Error loading trajectory:', err);
  //     }
  //   };

  //   loadTrajectory();

  //   const advancedTexture = AdvancedDynamicTexture.CreateFullscreenUI('UI');

  //   const textBlock = new TextBlock();
  //   textBlock.color = 'white';
  //   textBlock.fontSize = 24;
  //   textBlock.textHorizontalAlignment = TextBlock.HORIZONTAL_ALIGNMENT_LEFT;
  //   textBlock.textVerticalAlignment = TextBlock.VERTICAL_ALIGNMENT_TOP;
  //   textBlock.paddingTop = 10;
  //   textBlock.paddingLeft = 10;
  //   advancedTexture.addControl(textBlock);

  //   const createCubeWithText = (position, rotation, scale, textContent, direction, targetPosition, threshold, lerpSpeed, options = {}) => {
  //     const {
  //       textAlign = 'center',
  //       font = 'Poppins',
  //       imageUrl,
  //       videoUrl,
  //       fontsize = 50,
  //       distanceTop = 0,
  //       mediaHeight = 1,
  //       mediaWidth = 1,
  //       offsetDirection = 'none',
  //       offsetValue = 0,
  //       textOffsetX = 0.3,
  //       textOffsetY = 0.3,
  //       cover = false,
  //       playPosition = null // Expected input: new Vector3(x, y, z)
  //     } = options;

  //     const cube = MeshBuilder.CreateBox('cube', { width: scale.x, height: scale.y, depth: scale.z }, scene);
  //     cube.originalPosition = position.clone();
  //     cube.position = position.clone();
  //     cube.rotation = new Vector3(rotation.x * (Math.PI / 180), rotation.y * (Math.PI / 180), rotation.z * (Math.PI / 180));

  //     const offsetDistance = 4;

  //     const getOffsetPosition = () => {
  //       const offsetPosition = cube.originalPosition.clone();
  //       switch (direction) {
  //         case 'front':
  //           offsetPosition.x += offsetDistance;
  //           break;
  //         case 'back':
  //           offsetPosition.x -= offsetDistance;
  //           break;
  //         case 'left':
  //           offsetPosition.z += offsetDistance;
  //           break;
  //         case 'right':
  //           offsetPosition.z -= offsetDistance;
  //           break;
  //         case 'up':
  //           offsetPosition.y += offsetDistance;
  //           break;
  //         case 'down':
  //           offsetPosition.y -= offsetDistance;
  //           break;
  //         default:
  //           break;
  //       }
  //       return offsetPosition;
  //     };

  //     cube.position = getOffsetPosition();

  //     let material = new StandardMaterial('cubeMaterial', scene);

  //     material.diffuseColor = new Color3(1, 1, 1);
  //     material.emissiveColor = new Color3(1, 1, 1);
  //     material.specularColor = new Color3(0, 0, 0);
  //     material.backFaceCulling = false;
  //     cube.material = material;

  //     // Create the plane for media
  //     const textPlane = MeshBuilder.CreatePlane('textPlane', { width: scale.x - textOffsetX, height: scale.x - textOffsetY }, scene);

  //     // Position the plane slightly in front of the cube
  //     textPlane.setParent(cube); // Make the plane a child of the cube
  //     if (imageUrl || videoUrl) {
  //       textPlane.position = new Vector3(0, -distanceTop, -(scale.z / 2 + 0.01)); // Slightly in front of the cube
  //     } else {
  //       textPlane.position = new Vector3(0, 0, -(scale.z / 2 + 0.01)); // Slightly in front of the cube
  //     }

  //     const setOffsetPosition = (textPlane) => {
  //       const offsetPosition = textPlane.position.clone();
  //       switch (offsetDirection) {
  //         case 'top':
  //           offsetPosition.y -= offsetValue;
  //           break;
  //         case 'bottom':
  //           offsetPosition.y += offsetValue;
  //           break;
  //         case 'left':
  //           offsetPosition.x += offsetValue;
  //           break;
  //         case 'right':
  //           offsetPosition.x -= offsetValue;
  //           break;
  //         default:
  //           break;
  //       }
  //       return offsetPosition;
  //     };

  //     textPlane.position = setOffsetPosition(textPlane);
  //     // Set the plane's rotation, adding 45 degrees (π/4 radians) on the y-axis
  //     textPlane.rotation = new Vector3(
  //       0, // Inherit the cube's X rotation
  //       0, // Add 45 degrees (π/4 radians) to the Y rotation
  //       0 // Inherit the cube's Z rotation
  //     );

  //     let textMaterial = new StandardMaterial('mediaMaterial', scene);

  //     textMaterial.emissiveColor = new Color3(1, 1, 1);
  //     textPlane.material = textMaterial;

  //     // Add text overlay on the plane if provided
  //     if (textContent) {
  //       const advancedTexture = AdvancedDynamicTexture.CreateForMesh(textPlane);

  //       const textBlock = new TextBlock();
  //       textBlock.text = textContent;
  //       textBlock.color = '#000000';
  //       textBlock.fontFamily = font;
  //       textBlock.fontSize = fontsize; // Adjust font size as needed
  //       textBlock.textWrapping = true;

  //       switch (textAlign) {
  //         case 'center':
  //           textBlock.textHorizontalAlignment = TextBlock.HORIZONTAL_ALIGNMENT_CENTER;
  //           break;
  //         case 'left':
  //           textBlock.textHorizontalAlignment = TextBlock.HORIZONTAL_ALIGNMENT_LEFT;
  //           break;
  //         case 'justified':
  //           textBlock.textHorizontalAlignment = TextBlock.HORIZONTAL_ALIGNMENT_LEFT;
  //           break;
  //       }

  //       advancedTexture.addControl(textBlock);
  //     } else {
  //       textPlane.scaling = new Vector3(0, 0, 0);
  //     }

  //     let videoTexture = null;

  //     // Add text overlay on the plane if provided
  //     if (imageUrl || videoUrl) {
  //       // Create the plane for media
  //       const mediaPlane = MeshBuilder.CreatePlane('mediaPlane', { width: scale.x / mediaWidth, height: scale.y / mediaHeight }, scene);

  //       // Position the plane slightly in front of the cube
  //       mediaPlane.setParent(cube); // Make the plane a child of the cube
  //       mediaPlane.position = new Vector3(0, distanceTop, -(scale.z / 2 + 0.009)); // Slightly in front of the cube
  //       // Set the plane's rotation, adding 45 degrees (π/4 radians) on the y-axis
  //       mediaPlane.rotation = new Vector3(
  //         0, // Inherit the cube's X rotation
  //         0, // Add 45 degrees (π/4 radians) to the Y rotation
  //         0 // Inherit the cube's Z rotation
  //       );

  //       mediaPlane.position = setOffsetPosition(mediaPlane);

  //       let mediaMaterial = new StandardMaterial('mediaMaterial', scene);

  //       mediaMaterial.emissiveColor = new Color3(1, 1, 1);
  //       mediaPlane.material = mediaMaterial;

  //       if (imageUrl) {
  //         console.log('Loading image:', imageUrl);
  //         const texture = new Texture(
  //           imageUrl,
  //           scene,
  //           false,
  //           false,
  //           Texture.TRILINEAR_SAMPLINGMODE,
  //           () => {
  //             console.log('Image loaded successfully');
  //           },
  //           (error) => {
  //             console.error('Failed to load image:', error);
  //           }
  //         );
  //         // Invert the image on the Y-axis
  //         texture.vScale = -1;
  //         mediaMaterial.diffuseTexture = texture;
  //       } else if (videoUrl) {
  //         console.log('Loading video:', videoUrl);
  //         videoTexture = new VideoTexture('videoTexture', videoUrl, scene, true, true);
  //         // Invert the image on the Y-axis
  //         videoTexture.video.loop = true;
  //         videoTexture.video.autoplay = false; // Initially autoplay is false
  //         //videoTexture.video.muted = false; // Initially muted
  //         videoTexture.video.pause(); // Initially paused

  //         videoTexture.vScale = -1;
  //         mediaMaterial.diffuseTexture = videoTexture;

  //         // Store the video texture reference
  //         videoTexturesRef.current.push(videoTexture);
  //       }
  //     }

  //     cube.update = () => {
  //       const camera = cameraRef.current;
  //       if (!camera) return;

  //       const distanceToTarget = Vector3.Distance(camera.position, targetPosition);

  //       if (distanceToTarget < threshold) {
  //         cube.position = Vector3.Lerp(cube.position, cube.originalPosition, lerpSpeed);
  //       } else {
  //         cube.position = Vector3.Lerp(cube.position, getOffsetPosition(), lerpSpeed);
  //       }

  //       // Video play/stop logic
  //       if (playPosition) {
  //         const distanceToPlayPosition = Vector3.Distance(camera.position, playPosition);

  //         if (videoTexture) {
  //           if (distanceToPlayPosition < 1.0) {
  //             if (videoTexture.video.paused) {
  //               videoTexture.video.currentTime = 0; // Restart video from beginning
  //               //videoTexture.video.muted = false; // Unmute
  //               videoTexture.video.play().catch((e) => {
  //                 console.warn('Video play blocked:', e);
  //               });
  //             }
  //           } else {
  //             videoTexture.video.pause(); // Pause video
  //             //videoTexture.video.muted = false; // Mute
  //           }
  //         }
  //       }
  //     };

  //     scene.registerBeforeRender(() => {
  //       cube.update();
  //     });

  //     if (cover) {
  //       const mediaPlaneCover1 = MeshBuilder.CreatePlane('mediaPlaneCover', { width: 1.125, height: 1 }, scene);

  //       // Position the plane slightly in front of the cube
  //       mediaPlaneCover1.setParent(cube); // Make the plane a child of the cube
  //       mediaPlaneCover1.position = new Vector3(-1.11, 1.205, -(scale.z / 2 + 0.01)); // Slightly in front of the cube
  //       mediaPlaneCover1.rotation = new Vector3(
  //         0, // Inherit the cube's X rotation
  //         0, // Add 45 degrees (π/4 radians) to the Y rotation
  //         0 // Inherit the cube's Z rotation
  //       );

  //       // Create a dynamic texture
  //       const roundedCornersTexture = new DynamicTexture('roundedCornersTexture', { width: 512, height: 512 }, scene);

  //       // Get the 2D drawing context
  //       const context = roundedCornersTexture.getContext();

  //       // Set properties for the rounded rectangle
  //       const cornerRadius = 40; // Adjust for 5px at your plane's size
  //       const width = 512;
  //       const height = 512;

  //       // Clear the canvas
  //       context.clearRect(0, 0, width, height);

  //       // Draw the rounded rectangle
  //       context.fillStyle = 'white'; // Fill color for the rectangle
  //       context.beginPath();
  //       context.moveTo(cornerRadius, 0);
  //       context.lineTo(width - cornerRadius, 0);
  //       context.quadraticCurveTo(width, 0, width, cornerRadius);
  //       context.lineTo(width, height - cornerRadius);
  //       context.quadraticCurveTo(width, height, width - cornerRadius, height);
  //       context.lineTo(cornerRadius, height);
  //       context.quadraticCurveTo(0, height, 0, height - cornerRadius);
  //       context.lineTo(0, cornerRadius);
  //       context.quadraticCurveTo(0, 0, cornerRadius, 0);
  //       context.closePath();
  //       context.fill();

  //       // Apply the texture to the plane
  //       roundedCornersTexture.update();
  //       const material = new StandardMaterial('mediaPlaneCoverMaterial', scene);
  //       material.diffuseTexture = roundedCornersTexture;
  //       material.opacityTexture = roundedCornersTexture; // Make the corners transparent
  //       material.diffuseColor = new Color3(1, 1, 1); // White color
  //       material.emissiveColor = new Color3(1, 1, 1); // White color
  //       mediaPlaneCover1.material = material;

  //       const mediaPlaneCover2 = MeshBuilder.CreatePlane('mediaPlaneCover2', { width: 1.125, height: 1 }, scene);

  //       // Position the plane slightly in front of the cube
  //       mediaPlaneCover2.setParent(cube); // Make the plane a child of the cube
  //       mediaPlaneCover2.position = new Vector3(1.3, 1.1, -(scale.z / 2 + 0.01)); // Slightly in front of the cube
  //       mediaPlaneCover2.rotation = new Vector3(
  //         0, // Inherit the cube's X rotation
  //         0, // Add 45 degrees (π/4 radians) to the Y rotation
  //         0 // Inherit the cube's Z rotation
  //       );

  //       const mediaMaterial2 = new StandardMaterial('mediaMaterial', scene);

  //       mediaMaterial2.emissiveColor = new Color3(1, 1, 1);
  //       mediaPlaneCover2.material = mediaMaterial2;

  //       const mediaPlaneCover3 = MeshBuilder.CreatePlane('mediaPlaneCover3', { width: 2, height: 1 }, scene);

  //       // Position the plane slightly in front of the cube
  //       mediaPlaneCover3.setParent(cube); // Make the plane a child of the cube
  //       mediaPlaneCover3.position = new Vector3(0, 1.45, -(scale.z / 2 + 0.01)); // Slightly in front of the cube
  //       mediaPlaneCover3.rotation = new Vector3(
  //         0, // Inherit the cube's X rotation
  //         0, // Add 45 degrees (π/4 radians) to the Y rotation
  //         0 // Inherit the cube's Z rotation
  //       );

  //       mediaPlaneCover3.material = mediaMaterial2;

  //       const mediaPlaneLogo = MeshBuilder.CreatePlane('mediaPlaneLogo', { width: 1.8, height: 1.3 }, scene);

  //       // Position the plane slightly in front of the cube
  //       mediaPlaneLogo.setParent(cube); // Make the plane a child of the cube
  //       mediaPlaneLogo.position = new Vector3(0, 1.6, -(scale.z / 2 + 0.02)); // Slightly in front of the cube
  //       // Set the plane's rotation, adding 45 degrees (π/4 radians) on the y-axis
  //       mediaPlaneLogo.rotation = new Vector3(
  //         0, // Inherit the cube's X rotation
  //         0, // Add 45 degrees (π/4 radians) to the Y rotation
  //         0 // Inherit the cube's Z rotation
  //       );

  //       const mediaMaterialLogo = new StandardMaterial('mediaMaterial', scene);

  //       mediaMaterialLogo.emissiveColor = new Color3(1, 1, 1);
  //       mediaPlaneLogo.material = mediaMaterialLogo;

  //       const texture = new Texture(
  //         MajorVirtualTunnelLogo,
  //         scene,
  //         false,
  //         false,
  //         Texture.TRILINEAR_SAMPLINGMODE,
  //         () => {
  //           console.log('Image loaded successfully');
  //         },
  //         (error) => {
  //           console.error('Failed to load image:', error);
  //         }
  //       );
  //       // Invert the image on the Y-axis
  //       texture.vScale = -1;
  //       mediaMaterialLogo.diffuseTexture = texture;
  //     }

  //     return { cube };
  //   };

  //   const createSchermo = (position, rotation, scale, direction, targetPosition, threshold, lerpSpeed) => {
  //     SceneLoader.ImportMesh(
  //       '',
  //       '/Schermo.glb',
  //       '',
  //       scene,
  //       (meshes) => {
  //         if (meshes.length > 0) {
  //           const schermo = meshes[0];
  //           schermo.originalPosition = position.clone();
  //           schermo.position = new Vector3(position.x, position.y, position.z);
  //           schermo.rotation = new Vector3(rotation.x * (Math.PI / 180), rotation.y * (Math.PI / 180), rotation.z * (Math.PI / 180));
  //           schermo.scaling = new Vector3(scale.x, scale.y, scale.z);

  //           const offsetDistance = 4;

  //           const getOffsetPosition = () => {
  //             const offsetPosition = schermo.originalPosition.clone();
  //             switch (direction) {
  //               case 'front':
  //                 offsetPosition.x += offsetDistance;
  //                 break;
  //               case 'back':
  //                 offsetPosition.x -= offsetDistance;
  //                 break;
  //               case 'left':
  //                 offsetPosition.z += offsetDistance;
  //                 break;
  //               case 'right':
  //                 offsetPosition.z -= offsetDistance;
  //                 break;
  //               case 'up':
  //                 offsetPosition.y += offsetDistance;
  //                 break;
  //               case 'down':
  //                 offsetPosition.y -= offsetDistance;
  //                 break;
  //               default:
  //                 break;
  //             }
  //             return offsetPosition;
  //           };

  //           schermo.position = getOffsetPosition();

  //           schermo.update = () => {
  //             const camera = cameraRef.current;
  //             if (!camera) return;

  //             const distanceToTarget = Vector3.Distance(camera.position, targetPosition);

  //             if (distanceToTarget < threshold) {
  //               schermo.position = Vector3.Lerp(schermo.position, schermo.originalPosition, lerpSpeed);
  //             } else {
  //               schermo.position = Vector3.Lerp(schermo.position, getOffsetPosition(), lerpSpeed);
  //             }
  //           };

  //           scene.registerBeforeRender(() => {
  //             schermo.update();
  //           });

  //           onLoad(schermo);

  //           return { schermo };
  //         }
  //       },
  //       undefined,
  //       (error) => {
  //         console.error('Error loading Schermo.glb:', error);
  //       }
  //     );
  //   };

  //   createCubeWithText(
  //     new Vector3(-118.82, 1.6397, -1.29),
  //     new Vector3(0, -48.471 + 175, 0),
  //     new Vector3(4.44762, 4.374624, 0.1388885),
  //     null,
  //     'none',
  //     new Vector3(-124.5, 1.7, 3.0), // Trigger to move to original position
  //     0,
  //     0.05,
  //     {
  //       // imageUrl: MajorVirtualTunnelLogo, // Specify the image URL
  //       videoUrl: language === 'eng' ? AvatarENG : video1Avatar,
  //       textAlign: 'center',
  //       offsetDirection: 'top',
  //       offsetValue: 1.3,
  //       distanceTop: 0.7,
  //       fontsize: 42,
  //       mediaHeight: 1.4,
  //       mediaWidth: 1.6,
  //       cover: true,
  //       playPosition: new Vector3(-122.8, 0.8, 1.3)
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-112.584, -2.6593, -7.526),
  //     new Vector3(0, -53.355 + 180, 0),
  //     new Vector3(2.518579, 2.468904, 0.1388885),
  //     // eslint-disable-next-line quotes
  //     '',
  //     'right',
  //     new Vector3(-116.47, -2, -3.66), // Trigger to move to original position
  //     4,
  //     0.03,
  //     {
  //       imageUrl: language === 'eng' ? slide1ENG : slide1ITA,
  //       textAlign: 'left',
  //       distanceTop: 0,
  //       fontsize: 40,
  //       mediaHeight: 1,
  //       mediaWidth: 1
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-91.267, -2.205, -7.8614),
  //     new Vector3(0, 90, 0),
  //     new Vector3(3.08142, 3.230222, 0.1388885),
  //     // eslint-disable-next-line quotes
  //     '',
  //     'up',
  //     new Vector3(-98.55, -2.16, -7.11), // Trigger to move to original position
  //     3,
  //     0.03,
  //     {
  //       imageUrl: language === 'eng' ? slide2ENG : slide2ITA,
  //       distanceTop: 0,
  //       mediaHeight: 1,
  //       mediaWidth: 1
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-91.627, -2.317, 19.414),
  //     new Vector3(0, 0, 0),
  //     new Vector3(3.08142, 2.9142, 0.1388885),
  //     '',
  //     'down',
  //     new Vector3(-91.77, -2.22, 11.18), // Trigger to move to original position
  //     3,
  //     0.03,
  //     {
  //       imageUrl: language === 'eng' ? slide3ENG : slide3ITA,
  //       textAlign: 'center',
  //       distanceTop: 0,
  //       fontsize: 50,
  //       mediaHeight: 1,
  //       mediaWidth: 1
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-70.603, -2.107, -8.463),
  //     new Vector3(0, 180, 0),
  //     new Vector3(1.508047, 2.655847, 0.1388885),
  //     '',
  //     'right',
  //     new Vector3(-72.17, -2.26, -2.03), // Trigger to move to original position
  //     6,
  //     0.02,
  //     {
  //       imageUrl: language === 'eng' ? slide4ENG1 : slide4ITA1, // Specify the image URL
  //       textAlign: 'center'
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-73.053, -2.107, -8.6056),
  //     new Vector3(0, 180, 0),
  //     new Vector3(1.508047, 2.655847, 0.1388885),
  //     '',
  //     'right',
  //     new Vector3(-72.17, -2.26, -2.03), // Trigger to move to original position
  //     6,
  //     0.02,
  //     {
  //       imageUrl: language === 'eng' ? slide4ENG2 : slide4ITA2, // Specify the image URL
  //       textAlign: 'center'
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-35.91, -2.205, -5.63),
  //     new Vector3(0, 90, 0),
  //     new Vector3(3.68142, 3.230222, 0.1388885),
  //     '',
  //     'left',
  //     new Vector3(-43.1, -2.31, -7.42), // Trigger to move to original position
  //     3,
  //     0.03,
  //     {
  //       imageUrl: language === 'eng' ? slide5ENG : slide5ITA,
  //       textAlign: 'right',
  //       distanceTop: 0,
  //       fontsize: 40,
  //       mediaHeight: 1,
  //       mediaWidth: 1,
  //       offsetDirection: 'top',
  //       offsetValue: -0.3
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-5.785, -2.4526, -6.8),
  //     new Vector3(0, 90, 0),
  //     new Vector3(2, 2.142666, 0.14538),
  //     '',
  //     'up',
  //     new Vector3(-10.66, -2.4, -6.89), // Trigger to move to original position
  //     2,
  //     0.05,
  //     {
  //       imageUrl: language === 'eng' ? slide6ENG : slide6ITA,
  //       textAlign: 'left',
  //       distanceTop: 0,
  //       fontsize: 50,
  //       mediaHeight: 1,
  //       mediaWidth: 1
  //     }
  //   );

  //   createSchermo(
  //     new Vector3(-14, 0, -6.5),
  //     new Vector3(0, -21.307, 0),
  //     new Vector3(1, 1, 1),
  //     'down',
  //     new Vector3(-10.66, -2.4, -6.89), // Trigger to move to original position
  //     2,
  //     0.01
  //   );

  //   createCubeWithText(
  //     new Vector3(-6.9, -2.4648, -5.2),
  //     new Vector3(0, -21.307 + 90, 0),
  //     new Vector3(1.13, 1.96, 0.1388885),
  //     null,
  //     'down',
  //     new Vector3(-10.66, -2.4, -6.89), // Trigger to move to original position
  //     2,
  //     0.01,
  //     {
  //       // imageUrl: MajorVirtualTunnelLogo, // Specify the image URL
  //       videoUrl: language === 'eng' ? video6ENG : video6ITA,
  //       textAlign: 'center',
  //       offsetDirection: 'none',
  //       offsetValue: 0,
  //       distanceTop: 0,
  //       fontsize: 42,
  //       mediaHeight: 1,
  //       mediaWidth: 1,
  //       cover: false,
  //       playPosition: new Vector3(-10.66, -2.4, -6.89)
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(5.1, -1.895, 2.54),
  //     new Vector3(0, 180, 0),
  //     new Vector3(4, 2.4, 0.1388885),
  //     null,
  //     'up',
  //     new Vector3(3.7, -2.48, 6.85), // Trigger to move to original position
  //     2,
  //     0.01,
  //     {
  //       imageUrl: language === 'eng' ? slide7ENG : slide7ITA, // Specify the image URL
  //       // videoUrl: video1Avatar,
  //       textAlign: 'left',
  //       offsetDirection: 'left',
  //       offsetValue: 1.4,
  //       distanceTop: -0.1,
  //       fontsize: 42,
  //       mediaHeight: 1.1,
  //       mediaWidth: 1.1,
  //       cover: false,
  //       playPosition: new Vector3(-10.66, -2.4, -6.89)
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(2.62, -1.895, 2.54),
  //     new Vector3(0, 180, 0),
  //     new Vector3(1.5, 2.4, 0.1388885),
  //     '',
  //     'up',
  //     new Vector3(3.7, -2.48, 6.85), // Trigger to move to original position
  //     2,
  //     0.01,
  //     {
  //       textAlign: 'left',
  //       fontsize: 80
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-7.162, -2.4513, -1.3665),
  //     new Vector3(0, -90, 0),
  //     new Vector3(1.16, 2.05, 0.1388885),
  //     null,
  //     'back',
  //     new Vector3(-3.72, -2.56, -1.37), // Trigger to move to original position
  //     2,
  //     0.08,
  //     {
  //       // imageUrl: MajorVirtualTunnelLogo, // Specify the image URL
  //       videoUrl: language === 'eng' ? video8ENG : video8ITA,
  //       textAlign: 'center',
  //       offsetDirection: 'none',
  //       offsetValue: 0,
  //       distanceTop: 0,
  //       fontsize: 42,
  //       mediaHeight: 1,
  //       mediaWidth: 1,
  //       cover: false,
  //       playPosition: new Vector3(-3.72, -2.56, -1.37) // Trigger to move to original position
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(-2.953, -2.4513, -8.768),
  //     new Vector3(0, 180, 0),
  //     new Vector3(1.16, 2.05, 0.1388885),
  //     null,
  //     'right',
  //     new Vector3(-3.09, -2.58, -5.35), // Trigger to move to original position
  //     2,
  //     0.08,
  //     {
  //       // imageUrl: MajorVirtualTunnelLogo, // Specify the image URL
  //       videoUrl: language === 'eng' ? video9ENG : video9ITA,
  //       textAlign: 'center',
  //       offsetDirection: 'none',
  //       offsetValue: 0,
  //       distanceTop: 0,
  //       fontsize: 42,
  //       mediaHeight: 1,
  //       mediaWidth: 1,
  //       cover: false,
  //       playPosition: new Vector3(-3.09, -2.58, -5.35) // Trigger to move to original position
  //     }
  //   );

  //   createCubeWithText(
  //     new Vector3(35.65, -2.905, -7.16),
  //     new Vector3(0, 90, 0),
  //     new Vector3(3.88142, 2.230222, 0.1388885),
  //     '',
  //     'down',
  //     new Vector3(28.98, -2.23, -7.37), // Trigger to move to original position
  //     3,
  //     0.03,
  //     {
  //       imageUrl: language === 'eng' ? slide10ENG : slide10ITA,
  //       textAlign: 'center',
  //       distanceTop: 0.1,
  //       fontsize: 30,
  //       mediaHeight: 1,
  //       mediaWidth: 1,
  //       offsetDirection: 'right',
  //       offsetValue: 0
  //     }
  //   );

  //   /* {
  //     "position": {
  //       "x": -10.66222,
  //       "y": -2.4,
  //       "z": -6.89111
  //     },
  //     "rotation": {
  //       "x": 0.00201,
  //       "y": 1.37162,
  //       "z": 0.0043
  //     }
  //   } */

  //   canvasRef.current.addEventListener('wheel', handleScroll);
  //   canvasRef.current.addEventListener('touchstart', handleTouchStart);
  //   canvasRef.current.addEventListener('touchmove', handleTouchMove);
  //   canvasRef.current.addEventListener('touchend', handleTouchEnd);

  //   let previousScrollDirection = 1;

  //   engine.runRenderLoop(() => {
  //     scene.render();

  //     const camera = cameraRef.current;
  //     if (camera) {
  //       /* textBlock.text = `Camera Position: (${camera.position.x.toFixed(2)}, ${camera.position.y.toFixed(
  //         2
  //       )}, ${camera.position.z.toFixed(2)})\nCamera Rotation: (${camera.rotation.x.toFixed(
  //         2
  //       )}, ${camera.rotation.y.toFixed(2)}, ${camera.rotation.z.toFixed(2)})`; */

  //       // Determine scroll direction
  //       const currentScrollDirection = currentIndexRef.current > previousScrollDirection ? 1 : -1;

  //       // Update all cubes
  //       scene.meshes.forEach((mesh) => {
  //         if (mesh.update) {
  //           mesh.update(currentScrollDirection);
  //         }
  //       });

  //       previousScrollDirection = currentIndexRef.current;
  //     }
  //   });

  //   return () => {
  //     engine.dispose();
  //     canvasRef.current?.removeEventListener('wheel', handleScroll);
  //     canvasRef.current?.removeEventListener('touchstart', handleTouchStart);
  //     canvasRef.current?.removeEventListener('touchmove', handleTouchMove);
  //     canvasRef.current?.removeEventListener('touchend', handleTouchEnd);
  //   };
  // }, []);

  // const backToLoadScreen = () => {
  //   setLoading(true);
  //   setShowPortal(false);
  //   setTimeout(() => {
  //     setLoading(false);
  //     setShowPortal(true);
  //     setShowPortalView(true);
  //   }, 1000);
  // };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [loading]);

  // const resetCameraPosition = () => {
  //   if (trajectoryRef.current.length > 0) {
  //     const initialPoint = trajectoryRef.current[0];
  //     if (cameraRef.current && initialPoint) {
  //       cameraRef.current.position = new Vector3(initialPoint.position.x, initialPoint.position.y, initialPoint.position.z);
  //       cameraRef.current.rotation = new Vector3(initialPoint.rotation.x, initialPoint.rotation.y, initialPoint.rotation.z);
  //       currentIndexRef.current = 0;
  //     }
  //   }
  // };

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10010
          }}
        >
          {console.log('Loader is visible')} {/* Debugging log */}
          <Loader dimensions={'50px'} />
        </div>
      )}

      {showPortalView && <Intro showPortal={showPortal} handleEnterClick={() => handleEnterClick()} />}

      {/* {showOuttro && <Outtro showOuttro={showOuttro} handleOuttroClick={handleOuttroClick} />} */}
      
      {/* <canvas ref={canvasRef} style={{ width: '100vw', height: '100vh' }} />
      <div class="scrolldown" style={{ color: 'skyblue' }}>
        <div class="chevrons">
          <div class="chevrondown"></div>
          <div class="chevrondown"></div>
          <span
            style={{
              position: 'absolute',
              top: '40%',
              left: '0',
              height: '100%',
              width: '100%',
              textAlign: 'center',
              textJustify: 'center',
              color: 'rgba(0, 0, 0, 0.5)',
              fontSize: 'bold'
            }}
          >
            scroll
          </span>
        </div>
      </div> */}

      {/* <div
        style={{
          position: 'fixed',
          bottom: '140px',
          right: '20px',
          zIndex: 1000,
          overflow: 'visible'
        }}
      >
        {/* Language Button 
        <button
          onClick={() => {
            setDropdownVisible(!dropdownVisible);
            console.log('called: ', dropdownVisible);
          }} // Toggle dropdown visibility
          style={{
            padding: '10px 15px',
            background: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          <img
            src={language === 'eng' ? ukFlag : italyFlag} // Show selected flag
            alt={language === 'eng' ? 'English' : 'Italian'}
            style={{ width: '20px', height: '20px', borderRadius: '50%' }}
          />
        </button>

        {/* Dropdown Menu 
        {dropdownVisible && (
          <div
            style={{
              position: 'absolute',
              bottom: '50px',
              right: '0',
              background: 'rgba(0, 0, 0, 0.8)',
              borderRadius: '5px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
              overflow: 'hidden'
            }}
          >
            <button
              onClick={() => changeLanguage('eng')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 15px',
                background: 'none',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                width: '100%'
              }}
            >
              <img src={ukFlag} alt="English" style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
              English
            </button>
            <button
              onClick={() => changeLanguage('ita')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 15px',
                background: 'none',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                width: '100%'
              }}
            >
              <img src={italyFlag} alt="Italian" style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
              Italian
            </button>
          </div>
        )}
      </div>

      <button
        onClick={backToLoadScreen}
        style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          padding: '10px 15px',
          background: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        <IoHome />
      </button>
      <button
        onClick={resetCameraPosition}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          padding: '10px 15px',
          background: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        <RiResetLeftLine />
      </button>

      <button
        onClick={handleAVATRClick}
        style={{
          position: 'fixed',
          bottom: '200px',
          right: '20px',
          padding: '10px 15px',
          background: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          scale: '1.2'
        }}
      >
        <FaHeadSideVirus />
      </button> */}
    </>
  );
};

export default App;
